import React, { useEffect } from 'react';
import { usePDF, Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import ToggleButton from '@mui/material/ToggleButton';
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";


import Logo from '../../assets/images/erColor.png';
import Fuente from '../../assets/fonts/open-sans.ttf';

Font.register({
  family: 'Open Sans',
  src: Fuente
});

// Create styles
const styles = StyleSheet.create({
    page: {
        margin: '0cm 0cm',
    },
    section: {
        margin: '1cm 1cm 0cm', 
    },
    header: {
        position: 'fixed',
        top: '0cm',
        left: '0cm',
        right: '0cm',
        height: '2cm',
        paddingLeft: '30px',
        paddingRight: '30px',
        marginBottom: '10px',
        border: '3px solid black',
    },
    recuadro: {
        border: '1px solid black',
        padding: '10px',
    },

    texto: {
        fontSize: '9px',
      },
    texto_fecha: {
        fontSize: '11px',
        textAlign: 'right',
        marginTop: '10px',
        color: 'grey',
      },
    texto_fecha_recuadro: {
        fontSize: '11px',
        textAlign: 'center',
        marginTop: '10px',
        color: 'grey',
      },
    texto_negrita: {
        fontSize: 14,
        fontWeight: 'bold'
      },
    texto_oyd: {
        fontSize: 11,
        fontWeight: 'bold'
      },
    texto_negrita_encabezado: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center',
        marginTop: '-20px',
        textTransform: 'uppercase'
      },
    pageNumber: {
        position: 'absolute',
        fontSize: 9,
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
      },
    pageNumber2: {
        position: 'absolute',
        fontSize: 9,
        bottom: 10,
        left: 0,
        right: 30,
        textAlign: 'right',
        color: 'grey',
      },

    table: {
        width: '100%'
      },
    row: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #EEE',
        paddingTop: 8,
        paddingBottom: 8,
        fontSize: 8,
        marginLeft: '1cm',
        marginRight: '1cm'
      },
    headert: {
        margin: '1cm 1cm 0.5cm', 
        borderTop: 'none',
        backgroundColor: 'black',
        color: 'white',
        textAlign: 'center'
      },
    bold: {
        fontWeight: 'bold',
      },
      // So Declarative and unDRY 👌
    row1: {
        width: '10%',
        textAlign: 'center'
      },
    row2: {
        width: '10%',
        textAlign: 'center'
      },
    row3: {
        width: '35%',
        textAlign: 'left',
        marginLeft: '15px'
      },
    row32: {
      width: '45%',
      textAlign: 'left',
      marginLeft: '15px'
    },  
    row4: {
        width: '35%',
        textAlign: 'left',
        marginLeft: '15px'
      },
    row42: {
        width: '45%',
        textAlign: 'left',
        marginLeft: '15px'
    },  
    row5: {
        width: '10%',
        textAlign: 'center',
        marginRight: '2px'
      },
    row6: {
        width: '20%',
        textAlign: 'center'
      },
    row7: {
      width: '10%',
      textAlign: 'center'
    },  
    row1d: {
        width: '10%',
        textAlign:'right'
      },
    row2d: {
        width: '10%',
        textAlign:'right',
      },
    row3d: {
        width: '35%',
        textAlign:'left',
        marginLeft: '15px'
      },
    row32d: {
      width: '45%',
      textAlign:'left',
      marginLeft: '15px'
    },   
    row4d: {
        width: '35%',
        textAlign:'left',
        marginLeft: '15px'
      },
    row42d: {
      width: '45%',
      textAlign:'left',
      marginLeft: '15px'
    },  
    row5d: {
        width: '10%',
        textAlign:'right',
        marginRight: '5px'
      },
    row6d: {
        width: '20%',
        textAlign:'left',
        marginLeft: '15px'
      },
    row7d: {
      width: '10%',
      textAlign: 'center',
      marginLeft: '15px'
    },
    footer: {
      margin: '1cm',
    }    
});
var today = new Date(),
dateNow = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();

// Create Document Component
const Documento = (props) => (
    <Document>
        <Page size="A4" style={styles.page} orientation='portrait'>
            <View style={styles.section}>
                <View style={styles.header}>
                <Image
                    style={{marginLeft:'10px', width:'4cm', marginTop:'10px'}}
                    src={Logo}
                /> 
                    <Text style={styles.texto_negrita_encabezado}>LISTADO DE {props.tipo}</Text>
                </View>
                           
                <View style={styles.recuadro}>
                  {props.origen ? (<Text style={styles.texto_oyd}><p style={styles.texto_negrita}><b style={styles.bold}>Del organismo: </b></p>{props.origenId} - {props.origen}</Text>):(null)}
                  {props.destino ? (<Text style={styles.texto_oyd}><p style={styles.texto_negrita}>Al organismo: </p>{props.destinoId} - {props.destino}</Text>):(null)}  
                    <Text style={styles.texto_fecha_recuadro}>{props.rango}</Text>
                </View>
            </View>
            
            <View style={styles.table}>
              <View style={[styles.row, styles.bold, styles.headert]} fixed>
                {props.tipo_tramite === 'E' ?(<Text style={styles.row1}>Expediente</Text>):(null)}
                {props.tipo_tramite === 'T'? (<Text style={styles.row2}>Trámite</Text>):(null)}
                {props.tipo === 'pendientes' ?(<Text style={styles.row3}>Asunto</Text>):(<Text style={styles.row32}>Asunto</Text>)}
                {props.tipo === 'pendientes' ?(<Text style={styles.row4}>Iniciadores</Text>):(<Text style={styles.row42}>Iniciadores</Text>)}      
                {props.tipo === 'pendientes' ?(<Text style={styles.row7}>Fecha</Text>):(null)}
                {props.tipo === 'pendientes' ?(<Text style={styles.row6}>Organismo de origen</Text>):(null)}
                <Text style={styles.row5}>Folios</Text>
              </View>
              {props.datos.map((dato, indice) => (
                <View key={indice} style={styles.row} wrap={false}>
                  {props.tipo_tramite === 'E' ?(<Text style={styles.texto, styles.row1d}>{dato.expediente}</Text>):(null)}
                  {props.tipo_tramite === 'T'? (<Text style={styles.texto, styles.row2d}>{dato.tramiteInterno}</Text>):(null)}
                  {props.tipo === 'pendientes' ?(<Text style={styles.texto, styles.row3d}>{dato.asunto}</Text>):(<Text style={styles.texto, styles.row32d}>{dato.asunto}</Text>)}
                  {props.tipo === 'pendientes' ?(<Text style={styles.texto, styles.row4d}>{dato.iniciadores}</Text>):(<Text style={styles.texto, styles.row42d}>{dato.iniciadores}</Text>)}
                  {props.tipo === 'pendientes' ?(<Text style={styles.row7d}>{dato.fechaMovimiento}</Text>):(null)}
                  {props.tipo === 'pendientes' ?(<Text style={styles.row6d}>{dato.organismoOrigen}</Text>):(null)}
                  <Text style={styles.texto, styles.row5d}>{dato.cant_folios}</Text>
                </View>
              ))}
            </View>
      <View style={styles.footer} fixed>
        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
          `Página ${pageNumber} de ${totalPages}`
        )} />
        <Text style={styles.pageNumber2} render={({ pageNumber, totalPages }) => (
          `Impresión ${dateNow}`
        )} />
      </View>      
    </Page>

    </Document>
);


const ReporteSeguimiento = (props) => {
    
  const [instance, updateInstance] = usePDF({ document: <Documento tipo={props.tipo} origen={props.origen} destino={props.destino} rango={props.fecha_rango} datos={props.datos} tipo_tramite={props.tipo_tramite} destinoId={props.destinoId} origenId={props.origenId} /> });
  
  useEffect(() => {
  if (!instance.loading && props.datos.length !== 0 && props.datos.length <= 300) {
      window.open(instance.url, '', 'toolbar=yes, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=900, top=10');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instance.loading])

  return (
    
    <ToggleButton
        value="imprimir"
        title="Imprimir listado"
        disabled={(props.datos.length === 0 || props.datos.length > 300) || instance.loading}
        onClick={updateInstance}
        target="_blank"
        sx={{ border: 0, "&.Mui-disabled": { border: 0, } }}
    >
        <PrintOutlinedIcon />
    </ToggleButton>
    );
};

export default ReporteSeguimiento;